import { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';

const DataTables = ({ filter, columns, data }) => {
    const [filterText, setFilterText] = useState('');
    const [filteredData, setFilteredData] = useState([]);


    useEffect(() => {
        const filtered = (data || []).filter(item =>
            Object.values(item).some(value =>
                String(value).toLowerCase().includes(filterText.toLowerCase())
            )
        );
        setFilteredData(filtered);
    }, [filterText, data]);

    return (
        <div>
            <div className={`${!filter ? "d-none" : "d-block"} text-end`}>
                <input
                    type="text"
                    placeholder="Search..."
                    value={filterText}
                    onChange={e => setFilterText(e.target.value)}
                    style={{
                        marginBottom: '10px',
                        padding: '8px',
                        width: '300px',
                        borderRadius: '5px',
                        border: '1px solid #ccc'
                    }}
                />
            </div>
            <DataTable
                columns={columns}
                data={filteredData}
                pagination
                highlightOnHover
                striped
            />
        </div>
    )
}


export default DataTables